import { ViteSSG } from 'vite-ssg';
import RootComponent from '@/App.vue';
import { createPiniaWithRouter } from '@/plugins/pinia';
import i18n from '@/plugins/i18n';
import '@/utilities/strings.ts';
import '@/utilities/numbers.ts';
import '@/utilities/arrays.ts';
import { routerOptions, configureRouter } from '@/plugins/router';
import { initializeAnalyticsOnConsent } from '@/plugins/analytics';
import { SsgStateKey } from '@/utilities/ssg-state.ts';

console.debug(`${import.meta.env.PROD ? 'Production' : 'Development'} Build Version`, import.meta.env.VITE_BUILD_VERSION);

export const createApp = ViteSSG(RootComponent, routerOptions, ({ app, router, initialState }) => {
  const pinia = createPiniaWithRouter(router);
  app.use(pinia);
  app.provide(SsgStateKey, initialState);

  app.use(i18n);

  if (!import.meta.env.SSR) {
    initializeAnalyticsOnConsent(app, router);
  }

  configureRouter(router);
});
